/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCheckCancel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22 5H2v14h11v-2H4V7h16v4h2z" />
        <path d="M6 11h12V9H6zm0 4h7v-2H6zm14.293-1.707L18.5 15.086l-1.793-1.793-1.414 1.414 1.793 1.793-1.793 1.793 1.414 1.414 1.793-1.793 1.793 1.793 1.414-1.414-1.793-1.793 1.793-1.793z" />
      </g>
    </g>
  </Icon>
);
export { SvgCheckCancel as CheckCancel };
